import { useState, useEffect, useReducer } from 'react'
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Stack,
	TextField,
	Grid,
	Popover,
} from '@mui/material'
import { isEmpty } from 'lodash'

import { useTranslation } from 'react-i18next'

import { dateTimeTypes, getDefaultOperator, DEFAULT_LOGIC_OPERATOR } from 'utils/functions/helpers'
import { generateRandomID } from 'components/pages/dis/helpers'

import { AdditionalFilterCom } from '../../../../../../data/datagrid/CreatViewComponents/collapses/AdditionalFiltersCollapse'
import { DATA_OBJ_ACTION_TYPES } from '../../../../../../data/datagrid/CreatViewComponents/ViewDialogUtils'

export function FiltersSettingComponent(props) {
	const { allColumns, listActiveFieldsOptions, additionalFilter, additionalFilterDispatch } = props

	const handleAddFilter = () => {
		//const additionalFilter = viewDataObj?.additionalFilter ? [...viewDataObj.additionalFilter] : []
		const column = listActiveFieldsOptions?.length > 0 ? listActiveFieldsOptions[0] : null

		const type = column?.type ? column.type : ''
		const ope = getDefaultOperator(type)
		const newItem = {
			field: column?.name || column?.field,
			type: type,
			operator: ope,
			value: '',
			ranID: generateRandomID(),
			logicOperator: DEFAULT_LOGIC_OPERATOR,
		}

		additionalFilterDispatch({
			type: DATA_OBJ_ACTION_TYPES.ADD,
			target: {
				defaultItem: newItem,
			},
		})
	}

	return (
		<Stack spacing={2} mt={2} mr={2} ml={2} mb={2}>
			{additionalFilter.map((item, index) => {
				return (
					<AdditionalFilterCom
						key={item.id || item.ranID}
						index={index}
						item={item}
						additionalFilterDispatch={additionalFilterDispatch}
						listActiveFieldsOptions={listActiveFieldsOptions}
						allColumns={allColumns}
					/>
				)
			})}
			<div>
				<Grid container fullWidth spacing={1}>
					<Grid item xs={1} md={1} lg={1}></Grid>
					<Grid item xs={5} md={5} lg={5}>
						<Button variant="text" onClick={handleAddFilter}>
							+ Add filter
						</Button>
					</Grid>
				</Grid>
			</div>
		</Stack>
	)
}
